import React from 'react';
import icon from './';

export default icon(
  <g>
    <path d="M85 277.375h259.704L225.002 397.077 256 427l171-171L256 85l-29.922 29.924 118.626 119.701H85v42.75z" />
  </g>
);
